import { render, staticRenderFns } from "./overlay-reel.vue?vue&type=template&id=c90248b4&scoped=true&"
import script from "./overlay-reel.vue?vue&type=script&lang=js&"
export * from "./overlay-reel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90248b4",
  null
  
)

export default component.exports